import * as React from 'react';
import translate from '../../../../locale/translate';
import * as moment from 'moment';

import { CheckboxInput } from '../../common/Input';
import { NodeTagFilterEditor, NodeSystemFilterEditor } from '../../common/Editor';
import ISettings from './ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';
import { Tag } from '../../../../store/models';
import * as XLSX from 'xlsx/dist/xlsx.full.min.js'
import { connect } from 'react-redux';
import IState from '../../../../interfaces/states';
import { IReportSettings } from '../../../../interfaces';

interface IProps {
    data: { tags: Tag[] };
    settings: ISettings;
    handleChange: IInputChangeEventHandler;
    widgetData: any;
    reportSettings: IReportSettings;
}

export class Editor extends React.Component<IProps, void> {
    handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(evt.target.name, evt.target.checked);
    }

    handleExportClick(e, inventory: any) {
        e.preventDefault();
        console.debug("::: ListInventoryWidget.Editor.handleExportClick", inventory);

        const sheetData = inventory.map((container) => {
            const bios = container.inventory && container.inventory.BIOS && container.inventory.BIOS.length ? container.inventory.BIOS[0] : {};
            const os = container.inventory && container.inventory.OS && container.inventory.OS.length ? container.inventory.OS[0] : {};
            const win11Status = container.inventory && container.inventory.WIN_11_STATUS && container.inventory.WIN_11_STATUS.length ? container.inventory.WIN_11_STATUS[0] : {};

            const messages = [
                { message: win11Status.CPU_STATUS_MESSAGE, status: win11Status.CPU_STATUS },
                { message: win11Status.MEMORY_STATUS_MESSAGE, status: win11Status.MEMORY_STATUS },
                { message: win11Status.STORAGE_STATUS_MESSAGE, status: win11Status.STORAGE_STATUS },
                { message: win11Status.TPM_STATUS_MESSAGE, status: win11Status.TPM_STATUS }
            ].map(({ message, status }) => {
                return status !== 'COMPATIBLE' ? message : null;
            }).filter(Boolean);

            // If win11Status.TPM_VERSION can be converted to a number, use it; otherwise, use an empty string
            const tpm_version_field = isNaN(Number(win11Status.TPM_VERSION)) ? "UNKNOWN" : win11Status.TPM_VERSION;

            return {
                name: container.system.machineName,
                system_type: container.system.isServer ? translate.gettext('Server') : translate.gettext('Workstation'),
                status: container.status,
                is_vm: container.system.isVm ? translate.gettext('Yes') : translate.gettext('No'),
                system_manufacturer: bios.SYSTEMMANUFACTURER,
                system_model: bios.SYSTEMMODEL,
                system_version: bios.SYSTEMVERSION,
                chassis_model: bios.CHASSISMODEL,
                chassis_serial: bios.CHASSISSERIAL,
                os_name: container.system.osName,
                os_version: container.system.osVersion,
                os_servicepack: container.system.osServicePack,
                os_language: os.LANGUAGEID,
                os_install_date: os.INSTALLDATE,
                number_processors: container.system.numberOfProcessors,
                first_cpu: win11Status.CPU,
                architecture: container.system.architecture,
                total_ram: win11Status.MEMORY_TOTAL,
                total_disk_capacity: win11Status.STORAGE_TOTAL,
                tpm_version: tpm_version_field,
                last_boot: moment(container.system.lastBootUpTime).format("DD.MM.YYYY HH:mm:ss"),
                windows11Compatible: win11Status.WIN_11_STATUS,
                windows11CompatibleError: messages.join("; "),
            };
        });

        const cols = [
            translate.gettext("Name"),
            translate.gettext("System type"),
            translate.gettext("State"),
            translate.gettext("Is VM?"),
            translate.gettext("System manufacturer"),
            translate.gettext("System model"),
            translate.gettext("System version"),
            translate.gettext("Chassis model"),
            translate.gettext("Chassis serial"),
            translate.gettext("OS"),
            translate.gettext("OS version"),
            translate.gettext("OS Servicepack"),
            translate.gettext("OS language"),
            translate.gettext("OS install date"),
            translate.gettext("Number of processors"),
            translate.gettext("First processor"),
            translate.gettext("Architecture"),
            translate.gettext("Total RAM (MB)"),
            translate.gettext("Total disk capacity (MB)"),
            translate.gettext("TPM version"),
            translate.gettext("Last boot"),
            translate.gettext("Windows 11 compatible"),
            translate.gettext("Windows 11 compatible, Message"),
        ];

        const ws = XLSX.utils.json_to_sheet(sheetData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
            wb,
            ws,
            `Inventory Report ${new Date().toLocaleDateString()}`
        );
        XLSX.utils.sheet_add_aoa(ws, [cols], { origin: "A1" });

        XLSX.writeFile(wb, "InventoryReport.xlsx");
        return false;
    }

    render() {
        const { settings } = this.props;

        return (
            <div>
                {(this.props && this.props.widgetData && this.props.widgetData.inventory && this.props.widgetData.inventory && this.props.widgetData.inventory.data && !this.props.widgetData.inventory.loading) ? <div className="m-b-md">
                    <button className="btn btn-info" onClick={(e) => this.handleExportClick(e, this.props.widgetData.inventory.data)}>{translate.gettext('Export as XLSX')}</button>
                </div> : <div></div>}

                <h3>{translate.gettext('Filter')}</h3>

                {/* <NodeSystemFilterEditor {...this.props} /> */}
                <NodeTagFilterEditor {...this.props} />

                <h3>{translate.gettext('Options')}</h3>
                <CheckboxInput
                    label={translate.gettext('Show summary')}
                    name="displaySummary"
                    checked={settings.displaySummary}
                    onChange={this.handleChange.bind(this)} />

                <h3>{translate.gettext('Categories')}</h3>
                <CheckboxInput
                    label={translate.gettext('SYSTEM')}
                    name="displayCategorySYSTEM"
                    checked={settings.displayCategorySYSTEM}
                    onChange={this.handleChange.bind(this)} />
                <CheckboxInput
                    label={translate.gettext('BIOS/MAINBOARD')}
                    name="displayCategoryBIOS"
                    checked={settings.displayCategoryBIOS}
                    onChange={this.handleChange.bind(this)} />
                <CheckboxInput
                    label={translate.gettext('CPU')}
                    name="displayCategoryCPU"
                    checked={settings.displayCategoryCPU}
                    onChange={this.handleChange.bind(this)} />
                <CheckboxInput
                    label={translate.gettext('MEMORYDEVICE')}
                    name="displayCategoryMEMORYDEVICE"
                    checked={settings.displayCategoryMEMORYDEVICE}
                    onChange={this.handleChange.bind(this)} />
                <CheckboxInput
                    label={translate.gettext('DISK')}
                    name="displayCategoryDISK"
                    checked={settings.displayCategoryDISK}
                    onChange={this.handleChange.bind(this)} />
                <CheckboxInput
                    label={translate.gettext('DISPLAY')}
                    name="displayCategoryDISPLAY"
                    checked={settings.displayCategoryDISPLAY}
                    onChange={this.handleChange.bind(this)} />
                <CheckboxInput
                    label={translate.gettext('OS')}
                    name="displayCategoryOS"
                    checked={settings.displayCategoryOS}
                    onChange={this.handleChange.bind(this)} />
                <CheckboxInput
                    label={translate.gettext('OS_HOTFIX')}
                    name="displayCategoryOS_HOTFIX"
                    checked={settings.displayCategoryOS_HOTFIX}
                    onChange={this.handleChange.bind(this)} />
                <CheckboxInput
                    label={translate.gettext('LOCALINFO')}
                    name="displayCategoryLOCALINFO"
                    checked={settings.displayCategoryLOCALINFO}
                    onChange={this.handleChange.bind(this)} />
                <CheckboxInput
                    label={translate.gettext('PROGRAMS')}
                    name="displayCategoryPROGRAMS"
                    checked={settings.displayCategoryPROGRAMS}
                    onChange={this.handleChange.bind(this)} />
                <CheckboxInput
                    label={translate.gettext('NEVI')}
                    name="displayCategoryNEVI"
                    checked={settings.displayCategoryNEVI}
                    onChange={this.handleChange.bind(this)} />
            </div>
        );
    }
}

const mapStateToProps = (state: IState, props: IProps) => {
    const { widgetId } = state.widgetEditor;
    return {
        widgetData: state.widgetData[widgetId] || {},
        reportSettings: state.reportSettings,
    }
};

// Connect to state to get widget data
export default connect(
    mapStateToProps,
    {}
)(Editor);


// WEBPACK FOOTER //
// ./src/components/widget/inventory/listInventory/Editor.tsx